const urlprefetchInitial = {
	lastCall: 0,
	lastTimed: 0,
	queue: [],
	cache: JSON.parse(sessionStorage.getItem("urlPrefetch")) || {},
};
window.lastCall = 0;
export default (state = urlprefetchInitial, action) => {
	switch (action.type) {
	case "REQUEST_ROUTE": {
		return Object.assign({}, state, {
			...state,
			queue: [...state.queue, action],
		});
	}
	case "SHIFT_QUEUE": {
		return Object.assign({}, state, {
			...state,
			queue: [...state.queue.slice(0, 1), ...state.queue.slice(2)],
		});
	}

	case "SAVE_ROUTE": {
		const newState = Object.assign({}, state, {
			...state,
			lastCall: new Date().getTime(),
			cache: {
				...state.cache,
				[action.payload.url]: action.payload.data,
			},
		});
		try {
			sessionStorage.setItem("urlPrefetch", JSON.stringify(newState.cache));
		} catch (error) {
			console.log({ error });
			sessionStorage.removeItem("urlPrefetch");
		}
		return newState;
	}

	default:
		return state;
	}
};
